/*
 * @Description: 项目人员结算管理
 * @Date: 2024-08-17 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { agentManager } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import qs from 'qs';

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '项目人员结算管理',
  list: agentManager.taxRelationPushList,
  search: [
    'fullName',
    'phone',
    'projectName',
    'authStatus',
    'isEmploy',
    'dealTime',
    'isSettlement'
  ],
  requestNow: true,
  fields: [
    {
      type: 'selection',
      width: '40px',
      prop: 'selection',
      reserve: true
    },
    'fullName',
    'phone',
    'projectName',
    'projectNo',
    'enterpriseName',
    'createDt',
    'authStatus',
    'isEmploy',
    'isSettlement'
  ],
  moreBtnArr: [
    {
      name: '重置',
      icon: '',
      type: 'primary',
      plain: true,
      async fn(app, table) {
        table.init();
      }
    },
    {
      name: '导出',
      icon: '',
      type: 'warning',
      async fn(app, table) {
        const selectionRows = table.$refs.table.selection
          .map(item => item.id)
          .join(',');
        agentManager
          .taxRelationPushListExport({
            ids: selectionRows,
            ...table.searchQuery
          })
          .then(() => {
            table.$message.success('下载成功，前往下载中心查看');
          });
      }
    }
  ]
});

export default [{ name: '项目人员结算管理', childMenu: [part] }];
